import EDC from '@/components/games/shared/globals';
import CursorManager from '@/components/games/shared/cursor-manager';
import router from '@/router';
import Button from '@/components/games/shared/button';
/**
 *
 */
EDC.Games.ProfileCreated.Scenes.Main = function () {};
/**
 *
 */
EDC.Games.ProfileCreated.Scenes.Main.prototype.init = function () {
  this.bg = null;
  this.content = null;
  this.cursorManager = null;
  this.continueButton = null;
  this.scale.off('resize', this.resize, this);
};
/**
 *
 */
EDC.Games.ProfileCreated.Scenes.Main.prototype.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);
  this.cursorManager.resetCursor();

  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'profile-created-background');

  this.content = this.add.container();

  this.logo = this.add.sprite(0, 0, 'logo');
  this.logo.init_scale = 1;

  const title = this.add.sprite(0, 0, 'profile-created-title').setOrigin(0);
  const frame = this.add.sprite(title.x + title.width / 2, 450, 'profile-created-frame');
  const frameText = this.add.sprite(frame.x, frame.y, 'profile-created-text');

  this.continueButton = new Button(this, frame.x + frame.width / 2, 450).create(
    'profile-created-btn-continue-normal',
    'profile-created-btn-continue-hover',
  );
  this.continueButton.setClickCallback(this.onContinue.bind(this));

  this.content.add([title, frame, frameText]);

  this.cursorManager.setDefaultDraggableEvents(this.continueButton.getContainer());

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });
};
/**
 *
 */
EDC.Games.ProfileCreated.Scenes.Main.prototype.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;

  this.cameras.resize(width, height);

  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);

  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.5) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition((width - bounds.width) / 2,
    height / 2 - bounds.height + 100 * neededScale);

  this.logo.setScale(this.logo.init_scale * neededScale);
  this.logo.setPosition(this.content.x + bounds.width / 2 - 860 * neededScale,
    this.content.y + 115 * neededScale);

  this.continueButton.setScale(neededScale);
  this.continueButton.setPosition(this.content.x + bounds.width / 2,
    this.content.y + 700 * neededScale);
};
/**
 *
 */
EDC.Games.ProfileCreated.Scenes.Main.prototype.onContinue = function () {
  router.push({ name: 'game-type-picker' });
};
/**
 *
 */
EDC.Games.ProfileCreated.Scenes.Main.prototype.onAnotherWay = function () {
  router.push({ name: 'game-type-picker' });
};

export default EDC.Games.ProfileCreated.Scenes.Main;
